<template>
    <div class="frame" :class="{ loggedOut: !loggedIn }">
        <header class="header">
            <div class="headerBackground">
                <svg height="100%" width="100%" xmlns="http://www.w3.org/2000/svg">
                    <path d="M 28 64 A 1 1 0 0 0 16 64 A 1 1 0 0 0 28 64 L 96 64 L 141 36 L 245 36 A 1 1 0 0 0 257 36 A 1 1 0 0 0 245 36"
                    style="fill:none;stroke:#5fa9ff;stroke-width:5" />
                </svg> 
            </div>
            <div class="dropdown" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
                <button class="burger">
                    <div></div>
                    <div></div>
                    <div></div>
                </button>
                <ul v-if="showDropdown" class="dropdown-content">
                    <li><router-link to="/home">Home</router-link></li>
                    <li><router-link to="/home/about">About Us</router-link></li>
                    <li><router-link to="/home/services">Services</router-link></li>
                    <li><router-link to="/home/resources">Resources</router-link></li>
                    <li><router-link to="/home/contact">Contact Us</router-link></li>
                    <li><router-link to="/0200">Login</router-link></li>
                </ul>
            </div>
            <nav class="tabs">
                <ul>
                    <li>
                        <router-link to="/home/about">about us</router-link>
                    </li>
                    <li>
                        <router-link to="/home/services">services</router-link>
                    </li>
                    <li>
                        <router-link to="/home/resources">resources</router-link>
                    </li>
                    <li>
                        <router-link to="/home/contact">contact us</router-link>
                    </li>
                </ul>
            </nav>
            <router-link to="/home" class="logo">
                LD Power Automation
            </router-link>
            <router-link to="/0200" class="login">
                login
            </router-link>
        </header>
        <div class="content">
            <router-view />
        </div>
    </div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
	name: 'home',
	data() {
		return {
			loggedIn:false,
            showDropdown: false,
		}
	},
    async created () {
		if(api.getCookie("user") !=undefined && api.getCookie("user") != ''){
			this.loggedIn = true;
		}else {
            this.loggedIn = false;
        }
	},
}
</script>

<style scoped>
.frame{
    width:100%;
    background-color: var(--off-white);
    height: calc(100vh - 50px);
    font-family: Maison Neue Bold,sans-serif;
    overflow-y: scroll;
}

.loggedOut {
    height: 100vh;
}

.loggedOut .header {
    top:0px;
}

.loggedOut .headerBackground {
    top:0px;
}

.image {
    width: 100%;
}

.headerBackground {
    position: fixed;
    width: 100%;
    height: 96px;
    left:0px;
    top:50px;
    z-index:-1;
    background: linear-gradient(0.38turn, #160077 50%, #5fa9ff);
    overflow: hidden;
}

.header {
    background-color: var(--off-white);
    height:fit-content;
    padding: 0px 44px 4px 44px;
    width: 100%;
    position:fixed;
    top:50px;
    display: flex;
    z-index:5;
    align-items: center;
}

.header::after {
    display: block;
    background-color: #5fa9ff;
    bottom: 0;
    content: "";
    height: 4px;
    left:0;
    width: 100%;
    padding: 0px 44px;
    position: absolute;
}

.tabs ul {
    display:flex;
    margin: 0;
    position: static;
}

.tabs li {
    list-style-type: none;
    display: list-item;
    padding: 0 20px;
    height: 92px;
}

.tabs a {
    color: white;
    font-size:16px;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: .1em;
    line-height: 92px;
    display: block;
    position: relative;
}

.tabs a:hover {
    color: #89c0ff;
    cursor:pointer;
    text-decoration: none;
}

.tabs a::after {
    background-color: #5fa9ff;
    bottom: 0;
    content: "";
    height: 8px;
    left: 0;
    max-height: 0;
    position: absolute;
    transition: max-height .1s linear;
    width: 100%;
}

.tabs a:hover::after {
    max-height: 4px;
    transition: max-height .1s linear;
} 

.logo {
    position: absolute;
    display: block;
    left: 50%;
    top:0px;
    transform: translateX(-50%);
    font-size: 24px;
    font-weight: 700;
    letter-spacing: .1em;
    color: white;
    line-height: 92px;
}

.logo:hover {
    color:#89c0ff;
    cursor: pointer;
    text-decoration: none;
}

.login {
    position: absolute;
    display: block;
    top:0px;
    right: 44px;
    font-size: 16px;
    letter-spacing: .1em;
    color: black;
    line-height: 92px;
    text-decoration: none;
}

.login:hover {
    color:black;
    cursor: pointer;
    text-decoration: none;
}

.content {
    position: relative;
    top:96px;
    width:100%;
    padding:44px;
}

.dropdown {
    position: relative;
    display: inline-block;
}

.burger {
    appearance: none;
    background: transparent;
    border: 0;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 25px;
    outline: none;
    width: 50px;
}

.burger div {
    height: 2px;
    transition: transform .1s ease;
    width: 100%;
    background-color: black;;
}

.burger:hover div:first-child {
    transform: translateY(2px);
}

.burger:hover div:nth-child(3) {
    transform: translateY(-2px);
}

.dropdown-content {
    position: absolute;
    background-color: var(--off-white);
    box-shadow: 0px 8px 16px rgba(0,0,0,0.2);
    margin: 0;
    padding: 0;
    list-style: none;
    z-index: 1;
    width: 160px;
    display:block;
}

.dropdown-content li:hover {
    background-color: var(--off-white);
}

.dropdown-content a {
    display: flex;
    align-items: center;
    height: 60px;
    padding: 0 16px;
    box-sizing: border-box;
}

.dropdown-content a:hover {
    background-color: transparent;
}

@media (max-width: 1500px) {
    .tabs a {
        display:none;
    }

    .login {
        display: none;
    }
}

@media (min-width: 1500px) {
    .dropdown {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue